export const FETCH_ALL = 'blogs_List';

export const FETCH = 'blogs_FindById';

export const CREATE = 'blogs_CreateOne';

export const EDIT = 'blogs_UpdateById';

export const DELETE = 'blogs_RemoveManyByIds';
